import React from "react";
import { Typography } from "@material-ui/core";

interface IContentComponentProps {
  imagePath?: string;
  titleComponent?: React.ReactNode;
  descriptionComponent?: React.ReactNode;
  prices?: React.ReactNode;
}

export const ContentComponent: React.FC<IContentComponentProps> = (props: IContentComponentProps) => {
  return (
    <div>
      {props.titleComponent && <div>{props.titleComponent}</div>}
      {(props.descriptionComponent || props.imagePath) && (
        <div>
          {props.descriptionComponent && (
            <div>
              <Typography variant='h2'>{props.descriptionComponent}</Typography>
            </div>
          )}
          {props.imagePath && (
            <div>
              <img alt='' src={props.imagePath} />
            </div>
          )}
        </div>
      )}
      <div>{props.prices}</div>
    </div>
  );
};

export default ContentComponent;
